import React from "react";
import SaveIcon from "@mui/icons-material/Save";
import {IconButton} from "../../../features/management-v2/import/inputs";
import {useCreateContact} from "../hooks/useCreateContact";
import {GolemText} from "../../../lib/golem/GolemField";
import {GolemPhoneInput} from "../../../lib/golem/GolemPhoneInput";
import {useGolemErrors} from "../../../lib/golem/useGolemErrors";
import {FieldError} from "../../../lib/golem/FieldError";

export function ContactCreate() {
    const {
        firstName, setFirstName,
        lastName, setLastName,
        phoneMobileWork, setPhoneMobileWork,
        phoneMobilePersonal, setPhoneMobilePersonal,
        phoneHome, setPhoneHome,
        emailWork, setEmailWork,
        emailPersonal, setEmailPersonal,
        isLoading,
        submit,
    } = useCreateContact();

    const golemErrors = useGolemErrors();

    const handleSubmit = async () => {
        golemErrors.clearErrors();
        try {
            await submit();
        } catch (e) {
            golemErrors.setFromAxiosError(e);
        }
    };

    return (
        <div className="bg-white shadow-md p-4 flex flex-col gap-4">
            <h1 className="text-lg font-semibold">Create Contact</h1>
            <div className="grid grid-cols-2 gap-4">
                <GolemText label="First Name" value={firstName} onChange={setFirstName} errors={golemErrors} field="firstName" required/>
                <GolemText label="Last Name" value={lastName} onChange={setLastName} errors={golemErrors} field="lastName" required/>
                <GolemPhoneInput label="Work Mobile Phone" initialValue={phoneMobileWork} onChange={setPhoneMobileWork} errors={golemErrors} field="phoneMobileWork"/>
                <GolemPhoneInput label="Personal Mobile Phone" initialValue={phoneMobilePersonal} onChange={setPhoneMobilePersonal} errors={golemErrors} field="phoneMobilePersonal"/>
                <GolemPhoneInput label="Home Phone" initialValue={phoneHome} onChange={setPhoneHome} errors={golemErrors} field="phoneHome"/>
                <GolemText label="Work Email" value={emailWork} onChange={setEmailWork} errors={golemErrors} field="emailWork"/>
                <GolemText label="Personal Email" value={emailPersonal} onChange={setEmailPersonal} errors={golemErrors} field="emailPersonal"/>
            </div>
            <FieldError error={golemErrors.fieldError("_")}/>
            <IconButton text="Save" loading={isLoading} onClick={handleSubmit} icon={<SaveIcon/>} color="green"/>
        </div>
    );
}
